import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const ShareContainer = styled(motion.div)`
  background: linear-gradient(135deg, rgba(34, 197, 94, 0.12) 0%, rgba(34, 197, 94, 0.06) 100%);
  backdrop-filter: blur(25px);
  border-radius: 20px;
  padding: 30px;
  border: 2px solid rgba(34, 197, 94, 0.3);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);
  height: fit-content;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  will-change: auto;
  transform: translateZ(0);
  
  &:hover {
    border-color: rgba(34, 197, 94, 0.5);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5), 0 0 25px rgba(34, 197, 94, 0.2);
    transform: translateY(-3px) translateZ(0);
  }

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, rgba(34, 197, 94, 0.1) 0%, transparent 70%);
    animation: pulse 4s ease-in-out infinite;
  }

  @keyframes pulse {
    0%, 100% { transform: scale(1); opacity: 0.5; }
    50% { transform: scale(1.1); opacity: 0.8; }
  }
`;

const ShareTitle = styled.h3`
  color: #22c55e;
  font-size: 1.5rem;
  margin-bottom: 20px;
  font-weight: 700;
  text-align: center;
`;

const ShareButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const ShareButton = styled(motion.button)`
  background: linear-gradient(45deg, #22c55e, #16a34a);
  border: none;
  color: white;
  padding: 16px 28px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 700;
  font-size: 1rem;
  transition: all 0.4s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  position: relative;
  overflow: hidden;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    transform: translateY(-3px) scale(1.02);
    background: linear-gradient(45deg, #16a34a, #15803d);
    box-shadow: 0 12px 30px rgba(34, 197, 94, 0.4);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(-1px) scale(0.98);
  }

  &.download {
    background: linear-gradient(45deg, #22c55e, #16a34a);
    
    &:hover {
      background: linear-gradient(45deg, #16a34a, #15803d);
      box-shadow: 0 12px 30px rgba(34, 197, 94, 0.4);
    }
  }

  &.copy {
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    
    &:hover {
      background: rgba(255, 255, 255, 0.2);
      border-color: rgba(255, 255, 255, 0.4);
      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);
    }
  }
`;

const FomoSection = styled.div`
  background: rgba(34, 197, 94, 0.1);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid rgba(34, 197, 94, 0.2);
`;

const FomoTitle = styled.h4`
  color: #22c55e;
  font-size: 1.2rem;
  margin-bottom: 15px;
  font-weight: 600;
`;

const FomoText = styled.div`
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  font-size: 0.95rem;
`;

const Highlight = styled.span`
  color: #22c55e;
  font-weight: 700;
`;


function ShareSection() {
  const shareToTwitter = (lang) => {
    const texts = {
      zh: {
        text: "🚀 我的专属XWF头像！\n\n💎 CA: 0x7ea7bae59b389aad6fdd8d7ee48e114e35c1114a\n⛓️ 链: OKX Xlayer\n快来生成你的巫师帽：\n\n🔗 https://xwf.vercel.app/\n\n",
        hashtags: "XWF,Token,Crypto,OKX,MEME"
      },
      en: {
        text: "🚀 My exclusive XWF avatar!\n\n💎 CA: 0x7ea7bae59b389aad6fdd8d7ee48e114e35c1114a\n⛓️ Chain: OKX Xlayer\nCome generate your wizard hat:\n\n🔗 https://xwf.vercel.app/\n\n",
        hashtags: "XWF,Token,Crypto,OKX,MEME"
      }
    };

    const selectedText = texts[lang];
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(selectedText.text)}&hashtags=${selectedText.hashtags}`;
    window.open(twitterUrl, '_blank');
  };


  return (
    <ShareContainer
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, delay: 0.8 }}
    >
      <ShareTitle>🚀 一键分享</ShareTitle>
      
      {/* <FomoSection>
        <FomoTitle>🔥 分享文案</FomoTitle>
        <FomoText>
          创造你的专属XWF头像，展示你的独特风格！<br/>
          <Highlight>XWF百倍币就在这里！</Highlight><br/>
          加入XWF社区，与志同道合的投资者一起分享经验和机会。
        </FomoText>
      </FomoSection> */}

      <ShareButtons>
        <ShareButton
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => shareToTwitter('zh')}
        >
          🇨🇳 中文分享到推特
        </ShareButton>

        <ShareButton
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => shareToTwitter('en')}
        >
          🇺🇸 Share to Twitter
        </ShareButton>


      </ShareButtons>
    </ShareContainer>
  );
}

export default ShareSection;
